function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { Icon } from "./..";
import React, { useState } from 'react';
import "./index.less";
/**
 * description
 * title: Accordion的title ,
 * contentElement: 折叠区域的内容
 * foldState折叠状态,默认true
 * headerFontClass 头部文字样式自定义 传入一个class
 */
var Accordion = function Accordion(props) {
  var title = props.title,
    contentElement = props.contentElement,
    foldState = props.foldState,
    headerFontClass = props.headerFontClass;
  var _useState = useState(foldState),
    _useState2 = _slicedToArray(_useState, 2),
    isContentVisible = _useState2[0],
    setIsContentVisible = _useState2[1];
  var toggleContentVisibility = function toggleContentVisibility() {
    setIsContentVisible(!isContentVisible);
  };

  // //   icon
  // const downLine = <Icons type="downLine" customClassName="upLineIcon" />;
  // const upLine = <Icons type="upLine" customClassName="upLineIcon" />;

  return /*#__PURE__*/React.createElement("div", {
    className: "iron-accordion-header-with-transition"
  }, /*#__PURE__*/React.createElement("div", {
    onClick: toggleContentVisibility,
    className: "iron-accordion-header iron-flex"
  }, /*#__PURE__*/React.createElement("div", {
    className: "center ".concat(headerFontClass)
  }, title), /*#__PURE__*/React.createElement("div", {
    className: "right iron-flex"
  }, isContentVisible ? /*#__PURE__*/React.createElement(Icon, {
    name: "chevron-em-u"
  }) : /*#__PURE__*/React.createElement(Icon, {
    name: "chevron-em-d"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "iron-accordion-content ".concat(isContentVisible ? 'visible' : 'hidden')
  }, /*#__PURE__*/React.createElement(React.Fragment, null, contentElement)));
};
Accordion.defaultProps = {
  title: '默认titie',
  contentElement: undefined,
  // icon: <Icons type="downLine" customClass="upLineIcon" />,
  icon: '',
  foldState: true,
  headerFontClass: ''
};
export default Accordion;